<template>
	<div>
		<transition name="slide-fade">
			<vx-card :noShadow="true" :style="{width: isEventsListSidebarActive ? 'calc(100% - 450px)' : '100%'}">
				<div class="vx-row mb-2">
					<div class="vx-col w-full md:w-1/2 sm:w-1/1 flex flex-grow justify-end">
						<vx-tooltip delay=".1s" :text="notifyResources">
							<vs-button
								v-if="resource_ids.length > 0"
								class="ml-2"
								icon-pack="feather"
								icon="icon-bell"
								color="dark"
								type="flat"
								@click="sendNotifyConfirm(NOTIFY_ALL)"
								>{{ notifyResources }}
							</vs-button>
						</vx-tooltip>

						<vx-tooltip
							delay=".1s"
							:text="$t('Zonification.View') + ' ' + $t('OnDemand.AvailableResources')"
						>
							<vs-button
								v-if="resource_ids.length > 0"
								class="ml-2"
								icon-pack="feather"
								icon="icon-user-check"
								color="dark"
								size="large"
								type="flat"
								radius
								@click="popupResourceFoundActive = true"
							></vs-button>
						</vx-tooltip>
						<vx-tooltip
							delay=".1s"
							:text="$t('Zonification.View') + ' ' + $t('OnDemand.NoAvailableResources')"
						>
							<vs-button
								v-show="notFoundResources || resource_ids.length > 0"
								class="ml-2"
								icon-pack="feather"
								icon="icon-user-x"
								color="dark"
								size="large"
								type="flat"
								radius
								@click="unavailableResultPrompt = true"
							></vs-button>
						</vx-tooltip>
					</div>
				</div>
				<vs-alert
					class="mb-2 mt-2 g-label--normal"
					:color="availableResourcesAlert.color"
					:title="'Total ' + availableResourcesAlert.text"
					:active.sync="availableResourcesAlert.active"
					closable
					icon-pack="feather"
					close-icon="icon-x"
				>
					<div class="flex flex-grow justify-start mt-2 mb-2">
						<img
							:src="phonesSuccess"
							alt="resources"
							width="auto"
							height="37"
							v-if="availableResources.length > 0"
							:title="$t('OnDemand.AvailableResources')"
						/>
						<p class="ml-4 g-label--normal">
							{{ $t("OnDemand.SearchResultAlert") }}
						</p>
					</div>
				</vs-alert>
				<p class="mb-2 g-label--normal" v-show="event.id <= 0">{{ $t("OnDemand.AlertVisualizarInfo") }}</p>
				<div class="border border-solid d-theme-border-grey-light p-1" id="here-maps-content">
					<map-view-on-demand
						:key="renderComponent"
						name="map-iot"
						ref="moduleMap"
						latitude="4.686699"
						longitude="-74.0837187"
						zoom="13"
						height="82vh"
						width="100%"
						mapType="here"
						calledFrom="onDemand"
						:markerData="markerData"
						:addResourceMarkerTrigger="addResourceMarkerTrigger"
						:showResourceMarkerTrigger="showResourceMarkerTrigger"
						:hiddeResourceMarkerTrigger="hiddeResourceMarkerTrigger"
						:removeResourceLayerTrigger="removeResourceLayerTrigger"
						:OnDemandPolygonZones="polygonZones"
						@assignResourceToEventConfirmEmit="assignResourceToEventConfirm"
						@getResourceMarkersEmit="getResourceMarkers"
					/>
				</div>
			</vx-card>
		</transition>
		<vs-popup
			:fullscreen="false"
			:title="$t('OnDemand.SetFilters')"
			:active.sync="activeFilterPrompt"
			class="vs-popup--filter-content"
		>
			<div class="p-4" v-if="filterConfig">
				<vs-list>
					<vs-list-header :title="$t('OnDemand.AvailabilityFilters')" color="success"></vs-list-header>
					<vs-list-item title="" :subtitle="$t('OnDemand.FindResources') + ' (Km)'">
						<div class="flex flex-row justify-start">
							<vs-input
								class="mr-base"
								v-show="enabledRadius"
								v-model.number="filterConfig.distance"
								type="number"
								min="0"
							/>
							<vs-switch color="warning" v-model="enabledRadius" />
						</div>
					</vs-list-item>
					<vs-list-item title="" :subtitle="$t('OnDemand.AvailableResourcesEvents')">
						<div class="flex flex-row justify-start">
							<vs-input
								class="mr-base"
								v-show="enabledNumberEvents"
								type="number"
								min="0"
								v-model.number="filterConfig.number_events"
							/>
							<vs-switch color="warning" v-model="enabledNumberEvents" />
						</div>
					</vs-list-item>
					<vs-list-item title="" :subtitle="$t('OnDemand.AvailableResourcesText')">
						<vs-switch color="warning" v-model="filterConfig.availability" />
					</vs-list-item>
					<vs-list-header :title="$t('OnDemand.LocationFilters')" color="success"></vs-list-header>

					<vs-list-item title="" :subtitle="$t('OnDemand.AvailableResourcesLocation')">
						<div>
							<vs-radio
								v-model="filterConfig.location"
								vs-value="realtime"
								class="mr-2 font-small font-semibold"
								vs-name="layout-type-vertical"
							>
								<label :title="$t('OnDemand.AvailableResourcesLocationTrackingTitle')">{{
									locationOption.realtime
								}}</label></vs-radio
							>
							<vs-radio
								v-model="filterConfig.location"
								vs-value="location_default"
								class="mr-2 font-small font-semibold"
								vs-name="layout-type-vertical"
								><label :title="$t('OnDemand.AvailableResourcesLocationDefaultTitle')">{{
									locationOption.location_default
								}}</label></vs-radio
							>
						</div>
					</vs-list-item>
					<vs-list-item title="" :subtitle="locationZoneSubtitle">
						<vs-switch color="warning" v-model="filterConfig.location_zone" />
					</vs-list-item>
					<vs-list-item title="" :subtitle="$t('OnDemand.AvailableResourcesZoneRelated')">
						<vs-switch color="warning" v-model="filterConfig.related_zone" />
					</vs-list-item>
				</vs-list>
				<vs-divider />
				<div class="flex flex-wrap justify-start">
					<vs-button color="primary" class="mr-2" @click="getAvailableResources">{{
						$t("OnDemand.SearchResources")
					}}</vs-button>
					<vs-button color="warning" type="border" @click="clearFilter"
						>{{ $t("Schedule.Refresh") }} {{ $t("Filters") }}</vs-button
					>
				</div>
				<p>
					<vs-alert
						color="success"
						:title="$t('OnDemand.SetRadiusOnMapTitle')"
						:active.sync="circleAlert"
						closable
						icon-pack="feather"
						close-icon="icon-x"
					>
						<span>{{ $t("OnDemand.SetRadiusOnMapText") }}</span>
					</vs-alert>
				</p>
			</div>
		</vs-popup>
		<vs-popup
			:fullscreen="false"
			:title="$t('OnDemand.AvailableResources')"
			:active.sync="popupResourceFoundActive"
		>
			<resource-list
				v-if="resource_ids.length > 0 && popupResourceFoundActive"
				ref="ResourceList"
				componentParent="ON_DEMAND"
				:title="''"
				:searchOptions="false"
				:paginationEnable="false"
				:resource_ids="resource_ids"
				:multiple="multiple"
				:scrollArea="{
					margin: 'auto',
					width: '100%',
					'min-height': '100px',
					'max-height': '310px',
				}"
				:enableSearch="false"
			>
				<template v-slot:text>
					<vx-card no-shadow>
						<ul class="flex items-center justify-between">
							<li>
								<label>{{ $t("OnDemand.AssigResource") }}</label>
								<vs-switch v-model="assignSwitch" vs-icon="done" />
							</li>
							<li>
								<label>{{ notifyResources }}</label>
								<vs-switch v-model="notifySwitch" vs-icon="done" />
							</li>
						</ul>
					</vx-card>
				</template>
			</resource-list>
			<vs-button
				v-if="selectedResourceNotify"
				class="mt-4 float-right"
				color="primary"
				icon-pack="feather"
				:icon="buttonIcon"
				@click.prevent="handleSubmit"
				>{{ buttonText }}
			</vs-button>
		</vs-popup>
		<vs-popup
			:fullscreen="true"
			:title="$t('OnDemand.NoAvailableResources')"
			:active.sync="unavailableResultPrompt"
			class="vs-popup--result-content"
		>
			<vx-card card-border no-shadow>
				<resource-list
					v-if="unavailableResources.length > 0 && unavailableResultPrompt"
					ref="ResourceList"
					componentParent="ON_DEMAND"
					:title="''"
					:scrollArea="{
						margin: 'auto',
						width: '100%',
						'min-height': '400px',
						'max-height': '401px',
					}"
					:searchOptions="false"
					:paginationEnable="false"
					:resource_ids="unavailableResources.map(({resource_id}) => resource_id)"
					:multiple="multiple"
					:enableSearch="false"
					:enableSimpleSearchQuery="true"
				>
				</resource-list>
			</vx-card>
		</vs-popup>
	</div>
</template>

<script>
import DateUtils from "@/helpers/DateUtils.js";
import {sendFirebaseResourceNotifications} from "@/helpers/firebaseDB.js";
import VisitPoint from "@/models/VisitPoint.js";
import ResourceList from "@/components/calendar/ResourceList.vue";
import {db} from "@/main";
import Resource from "@/models/Resource.js";
import moduleResource from "@/store/resource/moduleResource.js";
import MapViewOnDemand from "./MapView";
import {addInteraction, centerMap, clearMap, fitBoundsMarkerGroup, removeCircles} from "../../core/plugins/ol/OlAnuket";
import EventProgrammed from "@/models/EventProgrammed.js";
import vSelect from "vue-select";
import Notification from "@/models/Notification.js";

export default {
	components: {
		MapViewOnDemand,
		ResourceList,
		vSelect,
	},
	props: {
		event: {
			type: EventProgrammed,
			required: true,
			default: () => new EventProgrammed({}),
		},
		onDemandConfig: {
			type: Object,
			required: true,
		},
		isEventsListSidebarActive: {
			type: Boolean,
			default: true,
		},
		activeFilterPromptTrigger: {
			type: Number,
		},
	},
	data() {
		return {
			show: false,
			permissionsRequired: false,
			msg: "",
			avatarImg: "",
			activePromptRadius: false,
			iconRight: false,
			shape: null,
			circleTimer: null,
			data_radius: 5,
			circleAlert: false,
			selectToolSelected: false,
			resource_ids: [],
			addResourceMarkerTrigger: 0,
			showResourceMarkerTrigger: 0,
			hiddeResourceMarkerTrigger: 0,
			markerData: [],
			latLngArray: [],
			multiple: false,
			assignSwitch: true,
			notifySwitch: false,
			notFoundResources: false,
			circle: null,
			selectedResourceReassign: null,
			location_zone: false,
			related_zone: false,
			number_events: 10,
			popupResourceFoundActive: false,
			NOTIFY_SELECTION: "NOTIFY_SELECTION",
			NOTIFY_ALL: "NOTIFY_ALL",
			NO_RESOURCE_TRACKING: "NO_RESOURCE_TRACKING",
			location: "realtime",
			polygonZones: null,
			AvailableResourcesEventsSwitch: false,
			enabledNumberEvents: true,
			enabledRadius: true,
			activeFilterPrompt: false,
			availableResourcesAlert: {
				active: false,
				color: "warning",
				title: this.$t("OnDemand.AvailableResources"),
				text: this.$t("OnDemand.AvailableResources"),
			},
			phonesSuccess: require("@/assets/images/markers/phones_success.png"),
			unavailableResultPrompt: false,
			filterConfig: null,
			removeResourceLayerTrigger: 0,
			renderComponent: 0,
		};
	},
	computed: {
		communicationCreatePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_C");
		},
		communicationUpdatePermission() {
			return this.$store.getters.checkPermission("COMMUNICATION_U");
		},
		messageDate() {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			return DateUtils.stringToDate(this.event.date_prog);
		},
		radius: {
			get() {
				return parseInt(this.data_radius);
			},
			set(val) {
				this.data_radius = val;
			},
		},
		selectedResourceNotify() {
			return this.$store.state.moduleResource.resources.some((r) => r.selected);
		},
		resources() {
			return this.$store.state.moduleResource.resources;
		},
		companyId() {
			return this.$store.state.AppActiveUser.datarutas_company_id;
		},
		availableResources() {
			return this.$store.state.moduleResource.availableResources.filter(
				({availability_on_demand}) => availability_on_demand
			);
		},
		unavailableResources() {
			return this.$store.state.moduleResource.availableResources.filter(
				({availability_on_demand}) => !availability_on_demand
			);
		},
		buttonText() {
			return this.assignSwitch ? this.$t("OnDemand.AssigResource") : this.notifyResources;
		},
		buttonIcon() {
			return this.assignSwitch ? "icon-user" : "icon-bell";
		},
		locationOption() {
			return {
				realtime: this.$t("OnDemand.AvailableResourcesLocationTracking"),
				location_default: this.$t("OnDemand.AvailableResourcesLocationDefault"),
			};
		},
		locationZoneSubtitle() {
			return `${this.$t("Resource.Resources")} ${this.$t("With")} ${this.locationOption[this.location]} ${this.$t(
				"OnDemand.AvailableResourcesZone"
			)}`;
		},
		notifyResources() {
			return this.$t("OnDemand.Notify") + " " + this.$t("Resource.Resources");
		},
	},
	methods: {
		cancel() {},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		clearFilter() {
			this.filterConfig = JSON.parse(JSON.stringify(this.onDemandConfig.config_json));
			this.enabledNumberEvents = true;
			this.enabledRadius = true;
			removeCircles();
		},
		openAlertPermission() {
			this.$vs.dialog({
				color: "danger",
				title: `${this.$t("Roles.Permissions.RequiredPermissionsText")} ${this.$t("Crud.Update")}`,
				text: this.$t("Roles.Permissions.NotPermissionsText"),
				acceptText: this.$t("Accept"),
			});
		},
		drawRadius() {
			this.circle = this.$refs.moduleMap.createCircle(
				[this.visitPoint.cx, this.visitPoint.cy],
				this.filterConfig.distance * 1000
			);
		},
		getAvailableResources() {
			// propiedad disparadora de eventos en el componente hijo
			removeCircles();
			this.hiddeResourceMarkerTrigger++;
			this.resource_ids = [];
			this.notFoundResources = false;
			this.openLoading();
			this.drawRadius();
			const {notify_on_create, automatic_assignment, ...restOfFilterConfig} = this.filterConfig;
			restOfFilterConfig.event_id = this.event.id;
			if (!this.enabledRadius) restOfFilterConfig.distance = false;
			if (!this.enabledNumberEvents) restOfFilterConfig.number_events = false;
			this.$store
				.dispatch("moduleResource/getAvailableResources", restOfFilterConfig)
				.then((res) => {
					if (this.availableResources.length > 0) {
						this.deleteShape();
						this.polygonZones = res.data.polygon_zones;
						return this.availableResources;
					} else {
						this.notFoundResources = true;
						throw new Error(this.NO_RESOURCE_TRACKING);
					}
				})
				.then((response) => {
					this.resource_ids = response.map(({resource_id}) => resource_id);
					this.markerData = response.map((element) => {
						let contactInfo = this.$store.getters["chat/contactImg"](+element.resource_id);
						let image = contactInfo ? contactInfo.img : "";
						let info = this.$store.getters["chat/contact"](+element.resource_id);
						return {
							...element,
							...info,
							img_url: image,
							cx: element.resource_cx,
							cy: element.resource_cy,
						};
					});
					this.addResourceMarkerTrigger++;
					this.latLngArray = this.createLatLngObjectArray(this.markerData);
					this.latLngArray.concat([
						{
							lat: parseFloat(this.event.cy),
							lng: parseFloat(this.event.cx),
						},
					]);
					this.closeLoading();
					this.moveScroll("here-maps-content");
					this.activeFilterPrompt = false;
					this.availableResourcesAlert = {
						color: "success",
						title: this.$t("OnDemand.SearchResources"),
						text: `${this.$t("OnDemand.NoAvailableResourcesText")} ${this.availableResources.length}`,
						active: true,
					};
				})
				.catch((err) => {
					this.closeLoading();
					this.deleteShape();
					this.removeResourceLayerTrigger++;
					if (err.message === this.NO_RESOURCE_TRACKING) {
						this.$vs.notify({
							color: "warning",
							title: this.$t("OnDemand.SearchResources"),
							text: this.$t("OnDemand.NoAvailableResourcesText"),
							icon: "person clear",
							time: 8000,
						});
					} else if (err.data.reason === "The current_day must be greater or equal date_prog") {
						this.$vs.notify({
							color: "warning",
							title: this.$t("OnDemand.SearchResources"),
							text: this.$t("OnDemand.NoAvailableResourcesDateText"),
							icon: "person clear",
							time: 8000,
						});
					} else {
						this.validateErrorMessages(err.data.reason);
					}
					this.activeFilterPrompt = false;
				});
		},
		circleManager(shape) {
			let radius = shape.getGeometry().getRadius();
			this.radius = parseInt(radius.toFixed(1));
		},
		selectTool(opc) {
			if (!this.selectToolSelected) {
				addInteraction(opc, this.$refs.moduleMap.olMap, (newShape) => {
					if (newShape && newShape.type === "Circle") {
						this.circleManager(newShape);
					}
				});
				this.circleAlert = true;
				this.selectToolSelected = true;
			} else {
				addInteraction(null, this.$refs.moduleMap.olMap, () => {});
				this.selectToolSelected = false;
				this.circleAlert = false;
			}
		},
		deleteShape() {
			if (this.shape === null) {
				return;
			}
			this.shape = null;
		},
		assignResourceToEvent() {
			// cambiamos la bandera que permite mostrar las notificaciones de aceptacion de eventos
			this.$store.commit("changeAceptedEventNotificationEnable", false);
			const event = {
				resource_id: this.selectedResourceReassign.id,
				event_id: this.event.id,
				event_status_id: 2,
			};
			this.openLoading();
			this.$store
				.dispatch("moduleSchedule/changeStatusEvent", event)
				.then((res) => {
					this.$store.commit("moduleSchedule/REMOVE_AVAILABLE_EVENT", [this.event]);
					this.$vs.notify({
						color: "success",
						title: this.$t("OnDemand.AssigResource"),
						text: this.$t("OnDemand.ResourcesAssigned"),
					});
					this.closeLoading();
					this.$router.push({name: "apps-on-demand-history"});
				})
				.catch((err) => {
					this.closeLoading();
					this.validateErrorMessages(err.data.reason);
				});
		},
		assignResourceToEventConfirm(value) {
			this.selectedResourceReassign = value;
			this.$vs.dialog({
				type: "confirm",
				color: "primary",
				title: this.$t("Confirm"),
				text: this.$t("OnDemand.ConfirmAssign"),
				accept: this.assignResourceToEvent,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		getResourceMarkers(val) {
			if (val) {
				fitBoundsMarkerGroup(val);
			}
		},
		validateErrorMessages(message) {
			let text = "";
			switch (message) {
				case "activity not available for the resource":
					text = this.$t("Schedule.ActivityNoAvailable");
					break;
				case "init_hour less than current time":
					text = this.$t("Schedule.ErrorProcess.InitHourError");
					this.init_hour_error = true;
					break;
				case "visit point is not related to resource":
					text = this.$t("Schedule.ErrorProcess.VisitpointError");
					break;
				case "resource has no activities":
					text = this.$t("Schedule.ErrorProcess.ResourceActivityError");
					break;
				case "The current date must be less than the event date_prog":
					text = this.$t("OnDemand.DateAssignedEnded");
					break;
				default:
					text = this.$t("ErrorMessage");
					break;
			}
			this.$vs.notify({
				time: 6000,
				color: "danger",
				title: this.$t("ErrorTitle"),
				text,
			});
		},
		/**
		 * TODO: Recuperar el tracking de los recursos recibidos en el array
		 * @param {Array} resources
		 */
		getResourceTracking(resources = []) {
			return new Promise(async (resolve, reject) => {
				if (resources.length > 0) {
					try {
						const fetches = resources.map((r) => {
							const starCountRef = db
								.ref(`tracking/${this.companyId}/`)
								.orderByChild("resource_id")
								.equalTo(r.resource_id + "");

							return starCountRef.once("value");
						});

						const snapshots = await Promise.allSettled(fetches);
						const trackings = snapshots
							.filter((snapshot) => snapshot.value.val())
							.map((snapshot) => Object.values(snapshot.value.val()))
							.flat();
						resolve(trackings);
					} catch (error) {
						reject(error.message);
					}
				} else {
					reject(new Error(this.NO_RESOURCE_TRACKING));
				}
			});
		},
		/**
		 *
		 * TODO: Extraer y guardar la coordenadas de cada recurso encontrado en un array recibido
		 * @param {Array} markerData
		 */
		createLatLngObjectArray(markerData) {
			return markerData.map((marker) => ({
				lat: parseFloat(marker.cy),
				lng: parseFloat(marker.cx),
			}));
		},
		addEventOnMap() {
			clearMap();
			this.visitPoint = new VisitPoint({
				...this.event,
				name: this.event.visit_point_name,
			});
			setTimeout(() => {
				this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint, false);
			}, 100);
		},
		getAvailableResourceInfo(id) {
			const foundResource = this.availableResources.find((r) => r.resource_id === id);
			if (foundResource) {
				return foundResource;
			}
			return null;
		},
		getResourceDistance(id) {
			const foundResource = this.availableResources.find((r) => r.resource_id === id);
			if (foundResource) {
				return foundResource.distance;
			} else {
				return "";
			}
		},
		sendNotifyConfirm(option) {
			this.$vs.dialog({
				type: "confirm",
				color: "primary",
				title: this.notifyResources,
				text: this.$t("OnDemand.SendNotify"),
				accept: () => this.sendNotify(option),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		sendNotify(option) {
			let resourcesToNotify = [];
			if (option === this.NOTIFY_SELECTION) {
				resourcesToNotify = [
					...this.availableResources.filter((resource) =>
						this.resources.find((r) => r.id === resource.resource_id)
					),
				];
			}
			if (option === this.NOTIFY_ALL) {
				resourcesToNotify = [...this.availableResources];
			}
			const notifyPromises = resourcesToNotify.map(({distance = "n/a", resource_id}) => {
				const notification = new Notification({
					body: {
						distance,
						events_id: [this.event.id],
						resource_id,
						init_date: this.event.date_prog,
						end_date: this.event.date_prog,
					},
					event: "EVENT_NOT_ASSIGNED",
					status: "unread",
					title: "Event available",
					to: "rt",
				});
				return sendFirebaseResourceNotifications(notification, resource_id, this.event.id);
			});
			Promise.all(notifyPromises).then((values) => {
				if (values.length > 0) {
					this.$vs.notify({
						color: "success",
						title: this.$t("OnDemand.Notify"),
						text: this.$t("OnDemand.ResourcesWereNotified"),
					});
				}
			});
		},
		/**
		 * TODO: Mover el scroll de la ventana al inicio del elemento id recibido en parametro
		 * @param {String} id atributo id html del elemento
		 */
		moveScroll(id) {
			const elem = document.getElementById(id);
			elem.scrollIntoView();
		},
		handleSubmit() {
			if (this.notifySwitch) {
				this.sendNotify(this.NOTIFY_SELECTION);
			}
			if (this.assignSwitch) {
				this.selectedResourceReassign = this.$store.state.moduleResource.resources.filter(
					(resource) => resource.selected
				)[0];
				if (this.selectedResourceReassign) this.assignResourceToEvent();
			}
			this.popupResourceFoundActive = false;
		},
	},
	watch: {
		isEventsListSidebarActive() {
			this.renderComponent += 1;
		},
		"event.id"(object) {
			if (object > 0) this.addEventOnMap();
			this.resource_ids = [];
			this.notFoundResources = false;
			removeCircles();
		},
		"selectedResourceReassign.id"(object) {
			if (object) {
				this.selectedResourceReassign;
			} else {
				this.getResourceMarkers();
				centerMap([parseFloat(this.event.cy), parseFloat(this.event.cx)], 3);
			}
		},
		assignSwitch(val) {
			if (val) {
				this.notifySwitch = false;
				this.multiple = false;
				const res = new Resource({});
				this.$store.commit("moduleResource/SET_SELECTED_RESOURCE", res);
			}
		},
		notifySwitch(val) {
			if (val) {
				this.assignSwitch = false;
				this.multiple = true;
			}
		},
		activeFilterPromptTrigger() {
			this.activeFilterPrompt = true;
		},
	},
	mounted() {
		if (this.event.id > 0) {
			this.addEventOnMap();
		}
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (Object.entries(this.onDemandConfig).length > 0) {
			this.filterConfig = JSON.parse(JSON.stringify(this.onDemandConfig.config_json));
		}
	},
};
</script>

<style lang="scss" scoped>
.vs-popup--filter-content {
	.vs-popup {
		width: 800px;
	}

	.btn-save {
		position: absolute;
		left: cal(100 vw- 10%);
		bottom: 30px;
	}

	.btn-del {
		position: absolute;
		left: 200px;
		bottom: 30px;
	}
}

.vs-popup--result-content {
	.vs-popup {
		width: 800px;
	}

	.not-available-resources {
		min-height: 460px;
	}
}

.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}
</style>
